import { JsonLd } from 'react-schemaorg';
import type { BreadcrumbList } from 'schema-dts';
import type { BreadcrumbItem } from '@//components/Breadcrumb';

interface SchemaBreadcrumbListProps {
  items: BreadcrumbItem[];
  baseUrl: string;
  currentPath: string;
}

const SchemaBreadcrumbList = ({ items, baseUrl, currentPath }: SchemaBreadcrumbListProps) => (
  <JsonLd<BreadcrumbList>
    item={{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items.map((item, index) => {
        const isLast = index === items.length - 1;
        const url = isLast ? currentPath : item.href;
        return {
          '@type': 'ListItem' as const,
          position: index + 1,
          name: item.label,
          ...(url && { item: `${baseUrl}${url}` }),
        };
      }),
    }}
  />
);

export default SchemaBreadcrumbList;
